import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FileNewFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.24 19.84H5.82V4.08H13.52L18.18 8.74V13.9C18.08 13.9 17.74 13.88 17.48 13.88C14.38 13.88 12.2 16 12.2 19C12.2 19.22 12.22 19.72 12.24 19.84ZM12.82 9.44H16.76L12.82 5.5V9.44ZM17.34 22.58C15.34 22.58 13.74 20.98 13.74 19.02C13.74 17.06 15.34 15.46 17.34 15.46C19.34 15.46 20.94 17.06 20.94 19.02C20.94 20.98 19.34 22.58 17.34 22.58ZM16.76 20.94H17.92V19.58H19.28V18.42H17.92V17.06H16.76V18.42H15.4V19.58H16.76V20.94Z" />
    </SvgIcon>
  );
});
